import { RegisterView } from '@pages/Auth';
import { createFileRoute } from '@tanstack/react-router';

interface RegisterSearch {
  invite_token?: string;
}

export const Route = createFileRoute('/_app/__not-auth/register')({
  component: function RegisterRoutePage() {
    const { invite_token: inviteToken } = Route.useSearch();

    return <RegisterView inviteToken={inviteToken} />;
  },
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    if (
      typeof search.invite_token === 'string' &&
      search.invite_token.length > 0
    ) {
      return { invite_token: search.invite_token };
    }

    return {};
  },
});
